import { __assign } from "tslib";
import React, { useContext } from 'react';
import { useDeepEqualMemo } from './hooks/useDeepEqualMemo';
// Helper to create a context provider component that instead of replacing
// parent values, it merges them with the provided ones
export function createMergingContextProvider(context, displayName) {
    if (displayName === void 0) { displayName = (context.displayName || 'Context') + "Provider"; }
    var MergingContextProvider = function (_a) {
        var children = _a.children, value = _a.value;
        var parentContext = useContext(context);
        var merged = useDeepEqualMemo(__assign(__assign({}, parentContext), value));
        return React.createElement(context.Provider, { value: merged }, children);
    };
    MergingContextProvider.displayName = displayName;
    return MergingContextProvider;
}
//# sourceMappingURL=createMergingContextProvider.js.map